
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AppAdministratorResourcesSupplementsListFormUpdate} from "@/models/app/administrator/resources/supplements/list/form/update";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElInput,
  ElButton,
} from "element-plus";
import {Edit} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "supplement",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElInput,
    ElButton,
    Edit,
  },
})
export default class AppAdministratorResourcesSupplementsListFormUpdateIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  supplement: AppAdministratorResourcesSupplementsListFormUpdate = new AppAdministratorResourcesSupplementsListFormUpdate();

  formData: AppAdministratorResourcesSupplementsListFormUpdate = new AppAdministratorResourcesSupplementsListFormUpdate();
  formDataRules = {
    content: {
      name: [
        {
          required: true,
          message: "Polje nije popunjeno",
          trigger: "blur",
        },
      ],
      description: [
        {
          required: true,
          message: "Polje nije popunjeno",
          trigger: "blur",
        },
      ],
    },
  };

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/administration/supplement/update",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getSupplements');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.supplement;
  }

  resetFormData(): void {
    this.formData = new AppAdministratorResourcesSupplementsListFormUpdate();
  }

  updated(): void {
    this.setFormData();
  }
}
